import BuildingIcon from '../../../icons/building.svg'

function toBuildingAsyncMultiValuedListMoreItem(option) {
  return {
    Icon: BuildingIcon,
    children: option.label.title,
    src: option.label.avatar,
  }
}

export function getDataItems(response) {
  return response.data.items.map(toBuildingAsyncMultiValuedListMoreItem)
}
